import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

export const isOnlineAtom = atom(true);

export const useIsOnlineWrapper = () => {
  const setOnlineStatus = useSetAtom(isOnlineAtom);

  useEffect(() => {
    if (!window || !navigator) return;

    const toggleOnlineStatus = () => setOnlineStatus(window.navigator.onLine);

    window.addEventListener('online', toggleOnlineStatus);
    window.addEventListener('offline', toggleOnlineStatus);

    return () => {
      window.removeEventListener('online', toggleOnlineStatus);
      window.removeEventListener('offline', toggleOnlineStatus);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

// boolean, before use useOnlineWrapper in global Wrapper Component
export const useIsOnline = () => {
  const isOnline = useAtomValue(isOnlineAtom);

  return isOnline;
};
